"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _PortalDismissStatus = _interopRequireDefault(require("EmailData/models/PortalDismissStatus"));

var _PortalEmailStatus = _interopRequireDefault(require("EmailData/models/PortalEmailStatus"));

var _PortalHealthStatus = _interopRequireDefault(require("EmailData/models/PortalHealthStatus"));

var defaults = {
  loading: false,
  dismissStatus: null,
  emailStatus: null,
  precogHealthStatus: null,
  disabledFunctionality: [],
  activePortalMessages: []
};

var PortalStatus =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PortalStatus, _Record);

  function PortalStatus() {
    (0, _classCallCheck2.default)(this, PortalStatus);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PortalStatus).apply(this, arguments));
  }

  (0, _createClass2.default)(PortalStatus, [{
    key: "isAllowedToSend",
    value: function isAllowedToSend() {
      return !this.emailStatus.isSuspended() && !this.precogHealthStatus.isSuspended();
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.loading;
    }
  }, {
    key: "isPortalSuspended",
    value: function isPortalSuspended() {
      return !this.isAllowedToSend();
    }
  }, {
    key: "getDismissStatus",
    value: function getDismissStatus() {
      return this.dismissStatus;
    }
  }, {
    key: "getHealthStatus",
    value: function getHealthStatus() {
      return this.precogHealthStatus;
    }
  }], [{
    key: "from",
    value: function from(json) {
      var dismissStatus = _PortalDismissStatus.default.from(json && json.dismissStatus ? json.dismissStatus : {});

      var emailStatus = _PortalEmailStatus.default.from(json && json.emailPortalStatus ? json.emailPortalStatus : {});

      var precogHealthStatus = _PortalHealthStatus.default.from(json && json.precogPortalStatus ? json.precogPortalStatus : {});

      return new PortalStatus((0, _extends2.default)({
        dismissStatus: dismissStatus,
        emailStatus: emailStatus,
        precogHealthStatus: precogHealthStatus
      }, json));
    }
  }]);
  return PortalStatus;
}((0, _immutable.Record)(defaults));

var _default = PortalStatus;
exports.default = _default;
module.exports = exports.default;